<template>
  <div class="threshold-list-container">
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="阈值名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入阈值名称"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <!-- 将查询和重置按钮放在最右边 -->
        <div class="filter-buttons" style="float: right;">
          <el-form-item>
            <el-button type="success" plain @click="handleFilter"
              >查询</el-button
            >
            <el-button plain @click="resetFilter">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="operation-container">
      <el-button
        type="success"
        size="mini"
        plain
        @click="handleAdd"
        icon="el-icon-plus"
        >新增阈值</el-button
      >
    </div>

    <el-table
      v-loading="loading"
      :data="thresholdList"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column
        label="序号"
        prop="No"
        width="80"
        align="center"
        type="index"
      />
      <el-table-column label="阈值名称" prop="name" min-width="150" />
      <el-table-column
        label="项目名称"
        prop="projectName"
        width="400"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="createDate"
        width="300"
        align="center"
      />
      <el-table-column
        label="更新时间"
        prop="updateDate"
        width="300"
        align="center"
      />
      <el-table-column label="操作" width="250" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="handleView(row)"
            >查看</el-button
          >
          <el-button type="text" size="small" @click="handleEdit(row)"
            >编辑</el-button
          >
          <!-- <el-button
            type="text"
            size="small"
            @click="handleExport(row)"
            style="color: #67C23A"
            >导出</el-button
          > -->
          <el-button
            type="text"
            size="small"
            @click="handleDelete(row)"
            style="color: #F56C6C"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 使用el-pagination分页组件 -->
    <el-pagination
      v-if="total > 0"
      :total="total"
      :current-page="queryParams.page"
      :page-size="queryParams.limit"
      :page-sizes="[10, 20, 30, 50]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      style="margin-top: 20px; text-align: right;"
    />
  </div>
</template>

<script>
import { getThresholdList, deleteThreshold } from "@/store/threshold";

export default {
  name: "ThresholdList",
  data() {
    return {
      loading: false,
      thresholdList: [],
      total: 0,
      queryParams: {
        // name: "",
        page: 1,
        limit: 10
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        // 根据request.js的解析，成功时返回data，失败时reject message
        const response = await getThresholdList(this.queryParams);
        // response 直接就是API返回的数据
        if (response && Array.isArray(response)) {
          // 如果返回的是数组
          this.thresholdList = response;
          this.total = response.length;
        } else if (response && response.list) {
          // 如果返回的是包含分页信息的对象
          this.thresholdList = response.list;
          this.total = response.total || response.list.length;
        } else {
          this.thresholdList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("获取阈值列表失败:", error);
        this.$message.error(
          typeof error === "string" ? error : "获取阈值列表失败"
        );
      } finally {
        this.loading = false;
      }
    },
    handleFilter() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetFilter() {
      this.queryParams = {
        name: "",
        page: 1,
        limit: 20
      };
      this.getList();
    },
    handleAdd() {
      this.$router.push("./add");
    },
    handleView(row) {
      this.$router.push(`./detail/${row.thresholdId}`);
    },
    handleEdit(row) {
      this.$router.push(`./edit/${row.thresholdId}`);
    },
    handleExport(row) {
      this.exportJson(row);
    },
    handleDelete(row) {
      this.$confirm(`确定删除阈值 "${row.name}" 吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            await deleteThreshold(row.thresholdId);
            this.$message.success("删除成功");
            this.getList();
          } catch (error) {
            this.$message.error(typeof error === "string" ? error : "删除失败");
          }
        })
        .catch(() => {});
    },
    exportJson(row) {
      try {
        // 可以选择导出格式
        this.$confirm("请选择导出格式", "导出选项", {
          confirmButtonText: "对象格式",
          cancelButtonText: "数组格式",
          type: "info"
        })
          .then(() => {
            // 导出对象格式
            const objectFormat = {};
            if (row.configs && Array.isArray(row.configs)) {
              row.configs.forEach(item => {
                if (item.key) {
                  // 尝试将value转换为数值类型
                  const numValue = Number(item.value);
                  objectFormat[item.key] = isNaN(numValue)
                    ? item.value
                    : numValue;
                }
              });
            }
            this.downloadJson(row, objectFormat, "object");
          })
          .catch(() => {
            // 导出数组格式
            const exportData = {
              name: row.name,
              configs: row.configs || []
            };
            this.downloadJson(row, exportData, "array");
          });
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败");
      }
    },
    downloadJson(row, data, format) {
      const dataStr = JSON.stringify(data, null, 2);
      const dataBlob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement("a");

      const timestamp = new Date().getTime();
      const fileName = `${row.name || "threshold"}_${format}_${timestamp}.json`;

      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      this.$message.success("导出成功");
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.queryParams.page = 1;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.threshold-list-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.filter-container {
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;

  /deep/ .el-form {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .filter-buttons {
    flex-shrink: 0;
  }
}

.operation-container {
  padding: 20px 0;
}

/* 表格样式优化 */
.el-table {
  margin-top: 10px;

  /deep/ .cell {
    line-height: 24px;
  }
}

/* 分页样式优化 */
.el-pagination {
  /deep/ .el-pagination__total {
    font-weight: 400;
  }

  /deep/ .el-pagination__jump {
    margin-left: 10px;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
    color: #fff;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #409eff;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/thresholdManagement/list.vue